import { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col, Row, Button, FormGroup, Input, Label, CardFooter, Alert, Table } from "reactstrap";
import { hideMenuTypeTabs, hideSchoolDrowdown, showMenuTypeTabs, showSchoolDrowdown } from "../../../../../actions/menuTypeAction";
import { useMenuTypeDispatch } from "../../../../../context/MenuTypeContext";
import { useAuthState } from "../../../../../context";
import { getNaSettingsById, insertSettingsRec, saveSettingsRec } from './../../../../../actions/naSettingsAction'
import { toast } from "react-toastify";
import { NaSettingsObj, SodiumTargets, SodiumLevelObj, ProductionRecordSettingObj } from './naSettings'
import { fetchMealPrograms } from "../../../../../actions/masterMenuAction";
import { groupBy } from "lodash";
import * as Icon from "react-bootstrap-icons";


const NutritionAnalysisSettings = (props) => {
    const dispatch = useMenuTypeDispatch();
    const { otherInfo } = useAuthState();
    const [naData, setNaData] = useState({});
    const [naSettings, setNaSettings] = useState({});
    const [naPrograms, setNaPrograms] = useState([]);
    const [loading, setLoading] = useState(false);
    // These settings only apply to sites that actually keep a production record.
    const productionRecSchools = ((otherInfo || {}).schools || []).filter(sch => {
        return (sch.moduleAccess || {})["Production Record"] == "Yes";
    });

    useEffect(() => {
        hideMenuTypeTabs(dispatch);
        hideSchoolDrowdown(dispatch);
        (async () => {
            await getMealPrograms();
            await getNutritionAnalysisSettings(otherInfo.catererId);
        })()
        return async () => {
            await showMenuTypeTabs(dispatch);
            await showSchoolDrowdown(dispatch);
        }
    }, []);
    useEffect(() => {
        formatReqObj();
    }, [naPrograms, naData]);
    const getMealPrograms = async () => {
        let data = [];
        try {
            const resp = await fetchMealPrograms();
            setNaPrograms(resp.data);
        } catch (error) {
            console.log(error);
        }
        return data;
    };

    const getNutritionAnalysisSettings = async (id) => {
        setLoading(true);
        const resp = await getNaSettingsById(id);
        setLoading(false);
        if (!resp.error) {
            setNaData(resp.data);
        } else {
            toast.error(resp.errorMessage);
        }
    }
    const onChangeRequiredPercentages = (e) => {
        naSettings[e.target.name] = e.target.valueAsNumber;
        setNaSettings({ ...naSettings });
    }
    const formatReqObj = () => {
        const dataObj = { ...NaSettingsObj };
        dataObj.id = naData.id;
        dataObj.catererAnalysisId = naData.catererAnalysisId;
        dataObj.wgrLimit = naData.wgrLimit;
        dataObj.fruitLimit = naData.fruitLimit;
        const existingProgObj = groupBy((naData.sodiumLevel || []), 'mealPrgram');
        dataObj.sodiumLevel = {};
        (naPrograms || []).map(prog => {
            const existingProgs = existingProgObj[prog.programName];
            const existingProgTargetGroup = groupBy(existingProgs, 'targetType');
            dataObj.sodiumLevel[prog.programName] = [];
            return SodiumTargets.map(targetType => {
                const existRec = existingProgTargetGroup[targetType];
                if ((existRec || []).length > 0) {
                    dataObj.sodiumLevel[prog.programName].push({
                        ...SodiumLevelObj,
                        mealPrgram: existRec[0].mealPrgram,
                        targetType: targetType,
                        enabled: existRec[0].enabled,
                        details: existRec[0].details
                    });
                } else {
                    dataObj.sodiumLevel[prog.programName].push({
                        ...SodiumLevelObj,
                        mealPrgram: prog.programName,
                        targetType: targetType,
                        enabled: (targetType == 'Target 1') ? true : false,
                    });
                }
            })
        })
        const existingProdRecObj = {};
        (naData.productionRecordSettings || []).forEach(rec => {
            existingProdRecObj[rec.mealSchoolId] = rec;
        });
        dataObj.productionRecordSettings = {};
        productionRecSchools.forEach(school => {
            const existRec = existingProdRecObj[school.schoolId] || {};
            dataObj.productionRecordSettings[school.schoolId] = {
                ovsEnabled: existRec.ovsEnabled || false,
                leftOverCodeEnabled: existRec.leftOverCodeEnabled || false
            };
        });
        setNaSettings({ ...dataObj });
    }
    const saveData = async () => {
        const reqObj = {
            ...naSettings,
            // catererId: otherInfo.catererId 
        };
        const sodiumLevel = [];
        Object.keys(naSettings.sodiumLevel).map(prog => {
            naSettings.sodiumLevel[prog].map(rec => {
                sodiumLevel.push({ ...rec });
            });
        });
        reqObj.sodiumLevel = JSON.stringify(sodiumLevel);
        const productionRecordSettings = Object.keys(naSettings.productionRecordSettings || {}).map(schoolId => {
            const rec = naSettings.productionRecordSettings[schoolId] || {};
            return {
                ...ProductionRecordSettingObj,
                mealSchoolId: Number(schoolId),
                ovsEnabled: rec.ovsEnabled || false,
                leftOverCodeEnabled: rec.leftOverCodeEnabled || false
            };
        });
        reqObj.productionRecordSettings = JSON.stringify(productionRecordSettings);

        setLoading(true);
        let resp = {};
        if ((reqObj.id || 0) > 0) {
            resp = await saveSettingsRec(reqObj, naData.id);
        } else {
            reqObj.catererAnalysisId = otherInfo.catererId;
            reqObj.wgrLimit = 0;
            reqObj.fruitLimit = 0;
            resp = await insertSettingsRec(reqObj);
        }
        setLoading(false);
        if (!resp.error) {
            toast.success(resp.data.message);
            getNutritionAnalysisSettings(otherInfo.catererId);
        } else {
            toast.error(resp.errorMessage);
        }
    }
    return (<>
        <Card className='p-2'>
            <CardHeader className='p-2 bg-light'>
                <Row className='align-items-center'>
                    <Col xs={12}><h5>{`Nutrition Analysis Settings`}</h5></Col>
                </Row>
            </CardHeader>
            <CardBody className='p-2'>
                <Row>
                    {/* <Col md={5}>
                        <Card className="border border-primary">
                            <CardBody>
                                <FormGroup row>
                                    <Label htmlFor="wgrLimit" sm={6} >
                                        Required WGR Limit % :
                                    </Label>
                                    <Col sm={3}>
                                        <Input id="wgrLimit" value={naSettings.wgrLimit} name="wgrLimit" type="number" onChange={(e) => onChangeRequiredPercentages(e)} />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label htmlFor="fruitLimit" sm={6} >
                                        Required Fruit Juice Limit % :
                                    </Label>
                                    <Col sm={3}>
                                        <Input id="fruitLimit" value={naSettings.fruitLimit} name="fruitLimit" type="number" onChange={(e) => onChangeRequiredPercentages(e)} />
                                    </Col>
                                </FormGroup>

                            </CardBody>

                        </Card>
                    </Col> */}
                    <Col md={5}>
                        <Card className="border border-primary">
                            <CardBody>
                                <ul>
                                    {
                                        naPrograms.map((program) => {
                                            const { programName, grades } = program
                                            return (<li>{programName}
                                                <ul>
                                                    {
                                                        (naSettings.sodiumLevel[programName] || []).map((item, i) => {
                                                            return <FormGroup check>
                                                                <Input
                                                                    id={`${item.mealPrgram}-${item.targetType}`}
                                                                    type="checkbox" checked={item.enabled}
                                                                    onChange={(e) => {
                                                                        naSettings.sodiumLevel[programName][i].enabled = e.target.checked;
                                                                        setNaSettings({ ...naSettings });
                                                                    }}
                                                                />
                                                                {' '}
                                                                <Label check>
                                                                    {`Active Sodium ${item.targetType.replace('Target ', '')}`}
                                                                </Label>
                                                            </FormGroup>

                                                        })
                                                    }
                                                </ul>
                                            </li>);
                                        })
                                    }
                                </ul>
                            </CardBody>
                            <CardFooter>
                                <Row>
                                    <Col className="text-center">
                                        <Alert color="primary">
                                            <span className="fs--1"><Icon.InfoCircleFill /> Sodium 2 requirements are optional and will not go into effect until July 1st, 2027</span>

                                        </Alert>
                                    </Col>
                                </Row>
                                <Row className="mt-2">
                                    <Col className="text-right">
                                        <Button size="sm" color="primary" onClick={(e) => saveData(e)}>Save</Button>

                                    </Col>
                                </Row>

                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md={6}>
                        <Card className="border border-primary">
                            <CardHeader className="p-2 bg-light">
                                <h6 className="mb-0">{`Production Record Settings`}</h6>
                            </CardHeader>
                            <CardBody className="p-2">
                                <Table size="sm" bordered responsive className="mb-0">
                                    <thead>
                                        <tr>
                                            <th>Site</th>
                                            <th className="text-center">OVS</th>
                                            <th className="text-center">Record Leftover Code</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {productionRecSchools.length <= 0 &&
                                            <tr>
                                                <td colSpan={3} className="fs--1">No sites with Production Record access.</td>
                                            </tr>}
                                        {productionRecSchools.map(school => {
                                            const schoolSettings = (naSettings.productionRecordSettings || {})[school.schoolId] || {};
                                            const updateSchoolSetting = (key, checked) => {
                                                const _settings = { ...(naSettings.productionRecordSettings || {}) };
                                                _settings[school.schoolId] = { ...(_settings[school.schoolId] || {}), [key]: checked };
                                                setNaSettings({ ...naSettings, productionRecordSettings: _settings });
                                            };
                                            return (<tr key={school.schoolId}>
                                                <td>{school.schoolName}</td>
                                                <td className="text-center">
                                                    <Input
                                                        id={`ovs-${school.schoolId}`}
                                                        type="checkbox"
                                                        className="position-static m-0"
                                                        checked={schoolSettings.ovsEnabled || false}
                                                        onChange={(e) => updateSchoolSetting('ovsEnabled', e.target.checked)}
                                                    />
                                                </td>
                                                <td className="text-center">
                                                    <Input
                                                        id={`leftover-code-${school.schoolId}`}
                                                        type="checkbox"
                                                        className="position-static m-0"
                                                        checked={schoolSettings.leftOverCodeEnabled || false}
                                                        onChange={(e) => updateSchoolSetting('leftOverCodeEnabled', e.target.checked)}
                                                    />
                                                </td>
                                            </tr>);
                                        })}
                                    </tbody>
                                </Table>
                            </CardBody>
                            <CardFooter>
                                <Row>
                                    <Col className="text-center">
                                        <Alert color="primary">
                                            <span className="fs--1"><Icon.InfoCircleFill /> These settings apply to every day at the selected site. OVS follows the setting on the production record, and Record Leftover Code adds a Leftover Code column to the grid and to the production record report.</span>
                                        </Alert>
                                    </Col>
                                </Row>
                                <Row className="mt-2">
                                    <Col className="text-right">
                                        <Button size="sm" color="primary" onClick={(e) => saveData(e)}>Save</Button>
                                    </Col>
                                </Row>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>

            </CardBody>
        </Card>

    </>);
}
export default NutritionAnalysisSettings;